import React, { Fragment } from 'react';
import styled from 'styled-components'
import ReactQuill, {Quill} from 'react-quill';
import Delta from 'quill-delta';
import ImageResize from 'quill-image-resize-module-react'
import 'react-quill/dist/quill.snow.css'
import './TextBoxQuill.css'

Quill.register('modules/imageResize', ImageResize)

var Image = Quill.import('formats/image')

// https://lingceng.github.io/blog/2018/03/28/custom-quill-dot-js-to-add-more-attributes-to-image/
class ImageBlot extends Image {
  static create(value) {
    if (typeof value == 'string') {
      return super.create(value);
    } else {
      return value;
    }
  }

  static value(domNode) {
    return domNode;
  }
}

Quill.register(ImageBlot, true);

// let yikes = ''
function filterImageMatcher(node, delta) {
  const protocol = node.src.split(':')[0]
  const ok = ['data', 'https'].includes(protocol)
  // yikes = `img src=${node.src}
  // protocol=${protocol}
  // ok=${ok}
  // delta=${JSON.stringify(delta, null, 2)}`
  if (!ok) {
    return new Delta()
  }
  return delta
}

  // https://github.com/quilljs/quill/issues/1690#issuecomment-572177679
  function selectPreventDefault(event) {
    event.preventDefault();
    event.stopPropagation();
}

class RichTextBox extends React.Component {
  constructor(props) {
    super(props)

    this.modules = {
      toolbar: "#toolbar",

      clipboard: {
        matchers: [
          // [Node.ELEMENT_NODE, filterImageMatcher]
          ['img', filterImageMatcher]
        ]
      },
      imageResize: {
        modules: ['Resize', 'DisplaySize'],
        toolbarStyles: {
          backgroundColor: 'black',
          border: 'none',
          color: 'white'
          // other camelCase styles for size display
        }
      }
    }
    this.formats = [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote', 'script', 'align',
      'list', 'bullet', 'indent', 'image', 'video', 'link', 'color', 'background'
    ]

  }

 componentDidMount() {
    let toolbar = document.getElementById('toolbar')
    let sticky = toolbar.offsetParent.offsetTop-50 // 50 is the navbar height

    window.onscroll = function () {
      if (window.pageYOffset > sticky) {
        toolbar.classList.add('sticky')
      } else {
        toolbar.classList.remove('sticky')
      }
    }

    // https://github.com/quilljs/quill/issues/1690#issuecomment-572177679
    document.querySelectorAll(".ql-picker").forEach(tool => {
      tool.addEventListener("mousedown", selectPreventDefault);
    });

  }

  componentWillUnmount() {
    window.onscroll = undefined
    document.querySelectorAll(".ql-picker").forEach(tool => {
      tool.removeEventListener("mousedown", selectPreventDefault);
    });
  }
  
  render() {
    return (
      <Fragment>
        <ToolBar id='toolbar'>
          <select className='ql-header' defaultValue='0' title='header line'>
            <option value='0'/>
            <option value='1'/>
            <option value='2'/>
            <option value='3'/>
          </select>
          <button className='ql-bold' title='bold'/>
          <button className='ql-italic' title='italic'/>
          <button className='ql-underline' title='underline'/>
          <button className='ql-strike' title='strike through'/>
          <button/>
          <button className='ql-list' value='ordered' title='number list'/>
          <button className='ql-list' value='bullet' title='bullet list'/>
          <button className='ql-blockquote' title='block quote'/>
          <button/>
          <button className='ql-script' value='sub' title='subscript'/>
          <button className='ql-script' value='super' title='superscript'/>
          <button/>
          <button className='ql-align' title='align left'/>
          <button className='ql-align' value='center' title='align center'/>
          <button className='ql-align' value='right' title='align right'/>
          <button className='ql-align' value='justify' title='align justify'/>
          <button/>
          <button className='ql-indent' value='+1' title='indent'/>
          <button className='ql-indent' value='-1' title='undent'/>
          <button/>
          {/* <button className='ql-clean'/> */}
          <button className='ql-image' title='image'/>
          <button className='ql-video' title='video link'/>
          <button className='ql-link' title='hyperlink'/>
          <button/>
          <select className='ql-color' title='color'/>
          <select className='ql-background' title='background'/>

        </ToolBar>

          <ReactQuill id='quillComponent'
            {...this.props}
            theme={"snow"}
            modules={this.modules}
            formats={this.formats}
            value={this.props.value}
            onChange={this.props.onChange}
          />
        {/* <textarea rows={25} cols={132} value={yikes}/> */}
      </Fragment>
    )
  }
}

const ToolBar = styled.div`
  background: #fff;
`

export default RichTextBox;